import { render } from "./questionComponent.vue?vue&type=template&id=0954b986&scoped=true"
import script from "./questionComponent.vue?vue&type=script&lang=js"
export * from "./questionComponent.vue?vue&type=script&lang=js"

import "./questionComponent.vue?vue&type=style&index=0&id=0954b986&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0954b986"]])

export default __exports__